<template>
    <b-button
        variant="dark"
        class="mb-2 mt-2 text-uppercase"
        block
        @click="openModalOferta"
        >Ofertar</b-button
    >
</template>
<script>
export default {
    props: ['id'],
    methods: {
        openModalOferta() {
            window.location.href = "/ofertar?step=1&ficha_tecnica=" + this.id;
        }
    }
}
</script>